import "./plugins/jquery.js";
import "./plugins/jquery-ui.min.js";
import "./plugins/jquery-mousewheel.js";
import "./plugins/imagesloaded.js";

import * as mfp from "./plugins/mfp.js";
import * as masonry from "./plugins/masonry.js";

import * as slick from "./plugins/slick.js";

export function init() {
  //imagesLoaded

  init_carousel();
  mfp.init();
  init_masonry();
}

export function init_masonry() {
  masonry.init();
}

// export function init_lazyload() {

//   jQuery("img.lazyload").lazyload({ data_attribute: "src" });
// }

export function init_carousel() {
  slick.init();
}
